
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/[country]/alle-wikifolios/suche",
      function () {
        return require("private-next-pages/[language]/[country]/alle-wikifolios/suche.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[language]/[country]/alle-wikifolios/suche"])
      });
    }
  